export default function CouponPastPC(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="996" height="153" viewBox="0 0 996 153" fill="none" {...props}>
            <mask id="path-1-inside-1_3277_7817" fill="white">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10C0 4.47716 4.47715 0 10 0H986C991.523 0 996 4.47716 996 10V63C984.954 63 976 71.7854 976 82.6226C976 93.4599 984.954 102.245 996 102.245V143C996 148.523 991.523 153 986 153H10C4.47716 153 0 148.523 0 143V102.245C11.0457 102.245 20 93.4599 20 82.6226C20 71.7854 11.0457 63 0 63V10Z"
                />
            </mask>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 10C0 4.47716 4.47715 0 10 0H986C991.523 0 996 4.47716 996 10V63C984.954 63 976 71.7854 976 82.6226C976 93.4599 984.954 102.245 996 102.245V143C996 148.523 991.523 153 986 153H10C4.47716 153 0 148.523 0 143V102.245C11.0457 102.245 20 93.4599 20 82.6226C20 71.7854 11.0457 63 0 63V10Z"
                fill="url(#paint0_linear_3277_7817)"
            />
            <path
                d="M996 63V65H998V63H996ZM996 102.245H998V100.245H996V102.245ZM0 102.245V100.245H-2V102.245H0ZM0 63H-2V65H0V63ZM10 -2C3.37258 -2 -2 3.37259 -2 10H2C2 5.58173 5.58172 2 10 2V-2ZM986 -2H10V2H986V-2ZM998 10C998 3.37259 992.627 -2 986 -2V2C990.418 2 994 5.58173 994 10H998ZM998 63V10H994V63H998ZM978 82.6226C978 72.9257 986.023 65 996 65V61C983.886 61 974 70.645 974 82.6226H978ZM996 100.245C986.023 100.245 978 92.3196 978 82.6226H974C974 94.6002 983.886 104.245 996 104.245V100.245ZM998 143V102.245H994V143H998ZM986 155C992.627 155 998 149.627 998 143H994C994 147.418 990.418 151 986 151V155ZM10 155H986V151H10V155ZM-2 143C-2 149.627 3.37259 155 10 155V151C5.58172 151 2 147.418 2 143H-2ZM-2 102.245V143H2V102.245H-2ZM18 82.6226C18 92.3196 9.97721 100.245 0 100.245V104.245C12.1142 104.245 22 94.6002 22 82.6226H18ZM0 65C9.97721 65 18 72.9257 18 82.6226H22C22 70.645 12.1142 61 0 61V65ZM-2 10V63H2V10H-2Z"
                fill="url(#paint1_linear_3277_7817)"
                mask="url(#path-1-inside-1_3277_7817)"
            />
            <defs>
                <linearGradient id="paint0_linear_3277_7817" x1="572.385" y1="-170.37" x2="633.028" y2="358.151" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0593887" stopColor="#3F68E0" />
                    <stop offset="0.315206" stopColor="#071B31" />
                    <stop offset="0.329737" stopColor="#071A2F" />
                    <stop offset="0.538019" stopColor="#05121F" />
                    <stop offset="0.69452" stopColor="#001934" />
                    <stop offset="1" stopColor="#3F68E0" />
                </linearGradient>
                <linearGradient id="paint1_linear_3277_7817" x1="-19.9146" y1="-68.9239" x2="314.018" y2="593.101" gradientUnits="userSpaceOnUse">
                    <stop offset="0.108269" stopColor="#2F2F2F" />
                    <stop offset="0.587124" stopColor="#C9C9C9" />
                    <stop offset="0.899897" stopColor="#363636" />
                </linearGradient>
            </defs>
        </svg>
    );
}
